// Module
var code = "<div id=\"content\">\n    <p>키워드와 관련 있는 단어를 시각화합니다.</p>\n</div>";
// Exports
module.exports = code;